var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReconocimientos(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#831131"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.7,175.5h-25.2V5.2H167c-1.7,0-124,1.2-143.4,1.3c-0.6-0.1-1.3-0.1-1.9-0.1c-11,0-20,9-20,20c0,0.3,0,0.6,0.1,0.9   c0,0.1,0,0.2,0,0.4L1.9,29h36.8V177h-0.1c0,11.2,9.1,20.4,20.4,20.4h117.2c11.2,0,20.4-9.1,20.4-20.4   C196.5,175.5,195.4,175.5,193.7,175.5z M21.3,9.4v0.1c0.1,0,0.9,0,2.3,0c8.4,0.9,15,7.9,15.2,16.5h-34C4.9,17,12.2,9.7,21.3,9.4z    M41.6,177.2h0.1V26.4l0,0c0,0,0,0,0,0c0-7.2-3.8-13.5-9.5-17c31.5-0.3,120.6-1.1,133.3-1.2v167.3H76.4v1.5   c0,9.6-7.8,17.4-17.4,17.4C49.5,194.3,41.8,186.6,41.6,177.2z M176.2,194.3H69.6c5.4-3.3,9.2-9.2,9.7-15.9c12.5,0,101.3,0,114.1,0   C192.7,187.3,185.2,194.3,176.2,194.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.8,
    y: 97.5,
    width: 36.1,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83,
    y: 114.1,
    width: 50.3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.3,
    y: 130.7,
    width: 57.9,
    height: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.8,75.2l4.6,4.6l4.6-4.6c5.4-1.6,9.7-5.8,11.3-11.3l4.1-4.1l-3.7-3.7c-1.3-6.5-6.4-11.7-13-13l-3.2-3.2l-3.2,3.2   c-6.6,1.3-11.7,6.4-13,13l-3.7,3.7l4.1,4.1C92.2,69.4,96.4,73.7,101.8,75.2z M93,57.6l0.1-0.5c0.9-5.7,5.4-10.1,11.1-11.1l0.5-0.1   l1.8-1.8l1.8,1.8l0.5,0.1c5.7,1,10.1,5.4,11.1,11.1l0.1,0.5l2.3,2.3l-2.5,2.5l-0.1,0.4c-1.2,4.7-4.9,8.4-9.6,9.6l-0.4,0.1l-3,3   l-3-3l-0.4-0.1c-4.7-1.2-8.4-4.9-9.6-9.6l-0.1-0.4l-2.5-2.5L93,57.6z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReconocimientos);
export default __webpack_public_path__ + "static/media/reconocimientos.2f83f93c80fa9eb1395fcc811c3a35a6.svg";
export { ForwardRef as ReactComponent };